import type { SubNavItem } from '../registry';

// Single source of truth for the Salary module's sub-navigation, shared by the
// in-page SalarySubNav (desktop/tablet) and the phone bottom bar (PortalLayout).
export const salarySubNavItems: SubNavItem[] = [
  { to: '/salary', label: 'Overview', end: true },
  { to: '/salary/periods', label: 'Pay Periods' },
  { to: '/salary/remittances', label: 'CRA Remittances' },
  { to: '/salary/t4', label: 'T4 Summary' },
  { to: '/salary/tax-brackets', label: 'Tax Brackets' },
  { to: '/salary/employer', label: 'Employer Profile' },
];
